<div class="am-content">
  <div class="main-content">
    <div class="page-head">
      <h2 class="title">Slotted Model</h2>
      <ol class="breadcrumb">
        <li>
          <a [routerLink]="NAVIGATIONS.HOME.route">{{
            NAVIGATIONS.HOME.name
          }}</a>
        </li>
        <li class="active">{{ NAVIGATIONS.SLOTTED.name }}</li>
      </ol>
    </div>
    <div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div [ngStyle]="{'border': !isPreSimulationFormValid ? 'none' : ''}" class="panel-heading">
              <div id="simulationSelectorPanel">
                <div id="simulationPanel">
                  <div *ngIf="simulationName == ''; else elseBlock">
                    Simulation
                  </div>
                  <ng-template #elseBlock>
                    <div>
                      <strong> Simulation: {{ simulationName }} </strong>
                    </div></ng-template
                  >
                </div>
                <div>
                  <div>
                    <div id="unitSystemPanel" class="form-group">
                      <label id="unitSystemLabel">Unit System</label>
                      <div class="am-radio inline">
                        <input
                          id="rdMetric"
                          type="radio"
                          name="radioOption"
                          class="input-xs"
                          value="metric"
                          disabled
                        />
                        <label for="rdMetric" class="input-xs">Metric</label>
                      </div>
                      <div class="am-radio inline">
                        <input
                          id="rdImperial"
                          type="radio"
                          checked="true"
                          name="radioOption"
                          class="input-xs"
                          value="imperial"
                        />
                        <label for="rdImperial" class="input-xs"
                          >Imperial</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-pre-simulation #preSimulation></app-pre-simulation>
            </div>
            <div [ngStyle]="{'display': !isPreSimulationFormValid ? 'none' : ''}" class="range-container">
              Complete the following fields: Model Validity 
              <span id="rangeModal" (click)="showRangeModal()" ><b>Ranges</b></span>
            </div>
            <div [ngStyle]="{'display': !isPreSimulationFormValid ? 'none' : ''}" class="panel-body">
              <form [formGroup]="fgSlottedPipe" (ngSubmit)="onSubmit()">
                <div class="row">
                  <app-slotted-type [fgSlottedPipe]="fgSlottedPipe">
                  </app-slotted-type>

                  <app-slotted-pipes
                    [fgSlottedPipe]="fgSlottedPipe"
                  ></app-slotted-pipes>
                </div>
                <div class="row">
                  <app-slotted-slots-scheme
                    [fgSlottedPipe]="fgSlottedPipe"
                  ></app-slotted-slots-scheme>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <app-slotted-lengths
                      [fgSlottedPipe]="fgSlottedPipe"
                    ></app-slotted-lengths>
                  </div>
                  <div class="col-md-4">
                    <app-slotted-notes
                      [fgSlottedPipe]="fgSlottedPipe"
                    ></app-slotted-notes>
                  </div>
                  <div class="col-md-4">
                    <app-slotted-attachments
                      [fgSlottedPipe]="fgSlottedPipe"
                    ></app-slotted-attachments>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <img
                      src="../../../../../assets/img/FullPipeLengths.png"
                      style="width: 100%"
                    />
                    <p style="text-align: center;">Fig. 7<br>Full pipe</p>
                  </div>
                  <div class="col-md-8">
                    <img *ngIf="dynamicImage" [src]="dynamicImage" style="width: 100%" />
                  </div>
                </div>
                <div class="row row-styles">
                  <div class="col-md-12" style="text-align: right">
                    <button
                      *ngIf="showDataCheck"
                      title="Data Check"
                      type="button"
                      class="datacheck"
                      (click)="preDataCheck()"
                      tabindex="-1"
                    >
                      Data Check
                    </button>
                    <button
                      #dataCheckButton
                      data-toggle="modal"
                      data-target="#dataCheckModal"
                      data-placement="right"
                      data-tooltip
                      *ngIf="showDataCheck"
                      type="button"
                      class="d-none"
                      tabindex="-1"
                    >
                      Check
                    </button>
                  </div>
                  <div
                    *ngIf="showPipeExists"
                    class="col-md-12"
                    id="inputContainer"
                  >
                    <div
                      style="margin-right: 1%"
                      [ngClass]="{
                        disabled: this.fgSlottedPipe.get('pipeExists').disabled
                      }"
                    >
                      <input
                        type="checkbox"
                        formControlName="pipeExists"
                        [ngClass]="{
                          'disabled-section':
                            this.fgSlottedPipe.get('pipeExists').disabled
                        }"
                      />
                    </div>
                    <p>I have checked that pipe exists</p>
                  </div>
                  <div class="col-md-12" id="submitRow">
                    <p *ngIf="showPipeExists" id="checkParagraph">
                      To enable simulation check flag: "I have checked that pipe
                      exists"
                    </p>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      [disabled]="fgSlottedPipe.invalid"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <app-slotted-results></app-slotted-results>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-slotted-ranges-modal></app-slotted-ranges-modal>
</div>

<app-data-check-modal></app-data-check-modal>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
